import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';
//SidebarToggleButtonComponent
@Component({
  selector: 'ubs-sidebar-toggle-button',
  template: `
    <div class="chat-assistant-container" [@pulseAnimation]="animationState">
      <button 
        class="chat-button" 
        (click)="toggleAssistant()" 
        (mouseenter)="onMouseEnter()" 
        (mouseleave)="onMouseLeave()"
        aria-label="Open chat assistant">
        <div class="button-content">
          <div class="icon-container">
            <!-- Collapse icon when sidebar is open -->
            <!-- Collapse icon SVG: arrow pointing right with vertical bar (on the left) -->
            <div class="collapse-icon" *ngIf="isSideBarOpen">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <!-- Sidebar edge (left vertical line) -->
                <line x1="5" y1="4" x2="5" y2="20" />
                <!-- Arrow pointing right -->
                <polyline points="13 8 17 12 13 16" />
              </svg>
            </div>
            <!-- Waving hand when not hovering -->
            <div class="hand-icon" *ngIf="!isHovering && !isSideBarOpen" [@waveAnimation]="waveState">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0"></path>
                <path d="M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2"></path>
                <path d="M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8"></path>
                <path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"></path>
              </svg>
            </div>
            <!-- Chat icon when hovering -->
            <div class="chat-icon" *ngIf="!isSideBarOpen && isHovering">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                <path d="M8 10h.01"></path>
                <path d="M12 10h.01"></path>
                <path d="M16 10h.01"></path>
              </svg>
             
            </div>
            
          </div>
          <span class="assistant-label" *ngIf="!isSideBarOpen">Chat Assistant</span>
        </div>
      </button>
    </div>
  `,
  styles: [`
    .chat-assistant-container {
      position: fixed;
      bottom: 20px;
      right: 20px;
      z-index: 1000;
    }
    
    .chat-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background-color: #4a86e8;
      color: white;
      border: none;
      box-shadow: 0 2px 10px rgba(0,0,0,0.2);
      cursor: pointer;
      transition: all 0.3s ease;
      overflow: hidden;
    }
    
    .chat-button:hover {
      width: 180px;
      border-radius: 30px;
    }
    
    .button-content {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    
    .icon-container {
      width: 24px;
      height: 24px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    
    .assistant-label {
      margin-left: 8px;
      white-space: nowrap;
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    
    .chat-button:hover .assistant-label {
      opacity: 1;
    }
    
    .hand-icon, .chat-icon {
      position: absolute;
      top: 0;
    }
    .hand-icon {
      left: 32px;
    }
    .chat-icon {
      left: 0;
    }
  `],
  animations: [
    trigger('pulseAnimation', [
      state('idle', style({
        transform: 'scale(1)'
      })),
      state('pulse', style({
        transform: 'scale(1.1)'
      })),
      transition('idle <=> pulse', animate('500ms ease-in-out'))
    ]),
    trigger('waveAnimation', [
      state('start', style({ transform: 'rotate(0deg)' })),
      state('end', style({ transform: 'rotate(0deg)' })),
      transition('start => end', [
        animate('1s', keyframes([
          style({ transform: 'rotate(0deg)', offset: 0 }),
          style({ transform: 'rotate(20deg)', offset: 0.25 }),
          style({ transform: 'rotate(-10deg)', offset: 0.5 }),
          style({ transform: 'rotate(10deg)', offset: 0.75 }),
          style({ transform: 'rotate(0deg)', offset: 1 })
        ]))
      ])
    ])
  ]
})
export class SidebarToggleButtonComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<any>();
  @Input() isSideBarOpen = false;
  
  animationState: 'idle' | 'pulse' = 'idle';
  waveState: 'start' | 'end' = 'start';
  animationInterval: any;
  waveInterval: any;
  isHovering = false;

  constructor() {}

  ngOnInit(): void {
    // Initial pulse animation
    setTimeout(() => {
      this.startPulseAnimation();
      setTimeout(() => {
        this.stopPulseAnimation();
      }, 3000);
    }, 1000);

    // Start waving hand animation
    this.startWaveAnimation();
  }

  toggleAssistant(): void {
    this.toggleSidebar.emit();
    this.isSideBarOpen = !this.isSideBarOpen;
  }

  onMouseEnter(): void {
    this.isHovering = true;
    this.stopWaveAnimation();
    this.startPulseAnimation();
  }

  onMouseLeave(): void {
    this.isHovering = false;
    this.stopPulseAnimation();
    this.startWaveAnimation();
  }

  startPulseAnimation(): void {
    if (!this.animationInterval) {
      this.animationInterval = setInterval(() => {
        this.animationState = this.animationState === 'idle' ? 'pulse' : 'idle';
      }, 1000);
    }
  }

  stopPulseAnimation(): void {
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
      this.animationInterval = null;
      this.animationState = 'idle';
    }
  }

  startWaveAnimation(): void {
    if (!this.waveInterval) {
      // Initial wave
      this.waveState = 'end';
      
      // Set up interval for continuous waving
      this.waveInterval = setInterval(() => {
        this.waveState = 'start';
        setTimeout(() => {
          this.waveState = 'end';
        }, 100);
      }, 3000); // Wave every 3 seconds
    }
  }

  stopWaveAnimation(): void {
    if (this.waveInterval) {
      clearInterval(this.waveInterval);
      this.waveInterval = null;
    }
  }

  ngOnDestroy(): void {
    this.stopPulseAnimation();
    this.stopWaveAnimation();
  }
}